var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M11.583 3.667A7.088 7.088 0 004.5 10.75a7.088 7.088 0 007.083 7.083H12v2.5c4.05-1.95 6.667-5.833 6.667-9.583a7.088 7.088 0 00-7.084-7.083zm.834 12.083H10.75v-1.667h1.667v1.667zm0-2.917H10.75c0-2.708 2.5-2.5 2.5-4.166C13.25 7.75 12.5 7 11.583 7c-.916 0-1.666.75-1.666 1.667H8.25a3.332 3.332 0 116.667 0c0 2.083-2.5 2.291-2.5 4.166z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2h20v20H2z"
  }))));
}

export default __webpack_public_path__ + "ondemand/static/8b50f6e88/icons/help.svg";
export { SvgHelp as ReactComponent };